"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _BalancesListComponent = _interopRequireDefault(require("./BalancesListComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    fetching: (0, _productPositionSelectors.fetchingSelector)(state),
    balances: (0, _productPositionSelectors.productPositionAssetsSelector)(state)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_BalancesListComponent["default"]);